import {DetailsList, PrimaryButton, SearchBox, SelectionMode} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {Link, useParams} from 'react-router-dom';
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import {whitespaceMatcher} from "../Utilities/WhitespaceMatcher";

function CounterDetails(props) {
    const [user] = useContext(AuthContext);
    const [projects, setProjects] = useState([]);
    const [name, setName] = useState([]);
    const [filteredProjects, setFilteredProjects] = useState([]);
    const [filter, setFilter] = useState('');

    const params = useParams();
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/counter/${params.id}`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setName(data[0].name); setProjects(data);})
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [params, user.token]);

    useEffect(() => {
        setFilteredProjects(projects.filter(item => whitespaceMatcher(filter, [item.number, item.project, item.venture].join(' '))));
        return filteredProjects;
    }, [filter, projects]);

    const columns = [
        {
            key: 'project',
            name: 'Projekt',
            ariaLabel: 'Projekt',
            fieldName: 'project',
            minWidth: 200,
            isResizable: true,
            isRowHeader: true,
            onRender: (item) => (<Link to={`/project/${item.project_id}`}><PrimaryButton text={`${item.project}`}/></Link>)
        },
        {
            key: 'venture',
            name: 'Kontrakt',
            ariaLabel: 'Kontrakt',
            fieldName: 'venture',
            minWidth: 90,
            maxWidth: 150,
            isResizable: true,
        },
        {
            key: 'number',
            name: 'Numer',
            ariaLabel: 'Numer Licznika',
            fieldName: 'number',
            minWidth: 120,
            isResizable: true,
        },
        {
            key: 'value',
            name: 'Wartość',
            ariaLabel: 'Wartość Licznika',
            fieldName: 'value',
            minWidth: 120,
            isResizable: true,
        }
    ];

    return (
        <AppContent title={`Licznik ${name}`} backTo={`/counter`}>
            <SearchBox placeholder="Wyszukaj" value={filter} onChange={(e, value) => setFilter(value)} />
            <DetailsList items={filteredProjects} columns={columns} selectionMode={SelectionMode.none} constrainMode={0}/>
        </AppContent>
    );
}

export default CounterDetails;